// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tsOVJ","right":"styles_right__uclh_"};